<template>
  <div
    class="informer"
    :class="{
        'informer_mobile': isMobile,
      }"
    :style="{
      color: textColor,
      backgroundColor: bgColor,
    }"
  >
    <div class="informer__content">
      <div class="informer__icon">
        <v-icon>{{ icon }}</v-icon>
      </div>
      <div class="informer__msg">{{ msg }}</div>
      <div
        class="informer__close"
        @click="close"
      >
        <v-icon
          :color="bgColor"
        >mdi-close</v-icon>
      </div>
    </div>
    <div class="informer__control">
      <v-btn
        v-for="(btn, key) in btns"
        :key="key"
        :small="!isMobile"
        outlined
        dark
        :to="btn.to"
        @click="click(btn.click)"
        elevation="0"
      >{{ btn.label }}</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    i: {type: Number, default: null},
    id: {type: Number, default: null},
    value: {type: Boolean, default: false},
    msg: {type: String, default: null},
    btns: {type: Array, default: () => []},
    bgColor: {type: String, default: '#fb8c00'},
    textColor: {type: String, default: '#fff'},
    icon: {type: String, default: 'mdi-exclamation'},
  },
  methods: {
    click(fn) {
      if (typeof fn === 'function') {
        fn(this.i, this.id);
      }
    },
    close() {
      this.$emit('close');
    }
  },
}
</script>

<style lang="scss">
.informer {
  max-width: 600px;
  border-radius: 4px;
  padding: 15px;

  &.informer_mobile {
    display: block;

    .informer__msg {
      font-size: 18px;
      margin-top: 5px;
    }

    .informer__close {
      width: 40px;
      height: 40px;
      margin-top: 0;
    }
  }

  .informer__icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 3px;

    .v-icon {
      color: #fff;
      font-size: 40px;
    }
  }

  .informer__content {
    display: flex;
    align-items: flex-start;
  }

  .informer__msg {
    flex: 1;
    font-size: 16px;
    padding: 0 15px 0 10px;
  }

  .informer__close {
    width: 30px;
    height: 30px;
    background-color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 4px;
    cursor: pointer;

    &:hover {
      background-color: rgba(255, 255, 255, 0.72);
    }
  }

  .informer__control {
    margin-top: 15px;
  }

  .v-alert {
    //padding-left: 32px;
    //padding-right: 32px;
  }

  .v-alert--prominent .v-alert__icon {
    height: 44px;
    min-width: 44px;
  }
}
</style>